
const courseFormUtils = {

    /***************************
     * Set values for patching
     ***************************/

    setInitialValues: ( form, values ) => {
        values.id =  form.getFieldValue( 'id' );
        values.isSequential = form.getFieldValue( 'isSequential' );

        // These are legacy and hidden from the UI
        values.isPublic = form.getFieldValue( 'isPublic' );
        values.metadata = form.getFieldValue( 'metadata' );
    },

    setILTValues: ( form, values ) => {
        if ( form.getFieldValue( 'isILTIsModified' ) === true ) {
            if ( form.getFieldValue( 'isILTModified' ) ) {
                values.isIlt = form.getFieldValue( 'isILTModified' );
            } else {
                values.isIlt = false;
            }
        } else {
            values.isIlt = form.getFieldValue( 'isIlt' );
        } 
    },

    setLocaleValues: ( form, values ) => {
        const l = form.getFieldValue( 'localesForSaving' );
        values.locales = l.length === 0 ? form.getFieldValue( 'locales' ) : l;
    },

    setHeroImageValues: ( form, values ) => { 
        if ( form.getFieldValue( 'heroImageIsModified' ) === true ) {
            if ( form.getFieldValue( 'heroImageModified' ) ) {
                values.heroImageId = form.getFieldValue( 'heroImageModified' )?.id;
            } else {
                values.heroImageId = null;
            }
        } else {
            values.heroImageId = form.getFieldValue( 'heroImage' )?.id;
        }
    },
    
    setThumbnailImageValues: ( form, values ) => { 
        if ( form.getFieldValue( 'thumbnailImageIsModified' ) === true ) {
            if ( form.getFieldValue( 'thumbnailImageModified' ) ) {
                values.thumbnailImageId = form.getFieldValue( 'thumbnailImageModified' )?.id;
            } else {
                values.thumbnailImageId = null;
            }
        } else {
            values.thumbnailImageId = form.getFieldValue( 'thumbnailImage' )?.id;
        }
    },

    setPointsValues: ( form, values ) => {
        if ( form.getFieldValue( 'pointsIsModified' ) === true ) {
            if ( form.getFieldValue( 'pointsModified' ) ) {
                values.points = Math.trunc( form.getFieldValue( 'pointsModified' ) );
            } else {
                values.points = null;
            }
        } else {
            values.points = form.getFieldValue( 'points' );
        }
    },

    setWeightValues: ( form, values ) => {
        if ( form.getFieldValue( 'weightIsModified' ) === true ) {
            if ( form.getFieldValue( 'weightModified' ) ) {
                values.weight = form.getFieldValue( 'weightModified' );
            } else {
                values.weight = null;
            }
        } else {
            values.weight = form.getFieldValue( 'weight' );
        }
    },

    setIsFeaturedValues: ( form, values ) => {
        if ( form.getFieldValue( 'isFeaturedIsModified' ) === true ) {
            if ( form.getFieldValue( 'isFeaturedModified' ) ) {
                values.isFeatured = form.getFieldValue( 'isFeaturedModified' );
            } else {
                values.isFeatured = null;
            }
        } else {
            values.isFeatured = form.getFieldValue( 'isFeatured' );
        }
    },

    /************************************
     * Get values for sync relationships
     ************************************/

    getTagSyncValues: ( form ) => {
        if ( form.getFieldValue( 'tagIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'tags',
                relatedResourceIds: form.getFieldValue( 'tagIdsModified' ) || []
            };
        }
    },

    getSegmentSyncValues: ( form ) => {
        if ( form.getFieldValue( 'segmentIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'segments',
                relatedResourceIds: form.getFieldValue( 'segmentIdsModified' ) || []
            };
        }
    },

    getCompanyRelationshipSyncValues: ( form ) => {
        if ( form.getFieldValue( 'companyRelationshipIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'company-relationships',
                relatedResourceIds: form.getFieldValue( 'companyRelationshipIdsModified' ) || []
            };
        }
    },

    getProductsSyncValues: ( form ) => {
        if ( form.getFieldValue( 'productIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'products',
                relatedResourceIds: form.getFieldValue( 'productIdsModified' ) || []
            };
        }
    },

    getLearningProfileSyncValues: ( form ) => {
        if ( form.getFieldValue( 'learningProfileIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'learning-profiles',
                relatedResourceIds: form.getFieldValue( 'learningProfileIdsModified' ) || []
            };
        }
    },

    getEmployeeLocaleSyncValues: ( form ) => {
        if ( form.getFieldValue( 'employeeLocaleIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'employee-locales',
                relatedResourceIds: form.getFieldValue( 'employeeLocaleIdsModified' ) || []
            };
        }
    },

    getLocalesSyncValues: ( form ) => {
        if ( form.getFieldValue( 'localeIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'locales',
                relatedResourceIds: form.getFieldValue( 'localeIdsModified' ) || []
            };
        }
    },

    getCategorySyncValues: ( form ) => {
        if ( form.getFieldValue( 'categoryIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'categories',
                relatedResourceIds: form.getFieldValue( 'categoryIdsModified' ) || []
            };
        }
    },

    getBrandSyncValues: ( form, isCreating ) => {
        if ( form.getFieldValue( 'brandIdsAreModified' ) === true ) {
            return {
                objectType: form.getFieldValue( 'type' ),
                objectId: form.getFieldValue( 'id' ),
                relatedResourceType: 'brands',
                relatedResourceIds: form.getFieldValue( 'brandIdsModified' ) || []
            };
        } else {
            if ( isCreating ) {
                return {
                    objectType: form.getFieldValue( 'type' ),
                    objectId: form.getFieldValue( 'id' ),
                    relatedResourceType: 'brands',
                    relatedResourceIds: form.getFieldValue( 'brandIdDefault' ) || []
                };
            }
        }
    },

    /******************************************************
     * Update form saved values, use this after save/patch
     ******************************************************/

    updateCategoryValues: ( form, values ) => {
        form.setFieldsValue( { categoryIds: values } ); 
        form.setFieldsValue( { categoryIdsAreModified: false } ); 
        form.setFieldsValue( { categoryIdsModified: [] } ); 
    },
    
    updateTagValues: ( form, values ) => {
        form.setFieldsValue( { tagIds: values } ); 
        form.setFieldsValue( { tagIdsAreModified: false } ); 
        form.setFieldsValue( { tagIdsModified: [] } ); 
    },
    
    updateSegmentValues: ( form, values ) => {
        form.setFieldsValue( { segmentIds: values } ); 
        form.setFieldsValue( { segmentIdsAreModified: false } ); 
        form.setFieldsValue( { segmentIdsModified: [] } ); 
    },
    
    updateCompanyRelationshipValues: ( form, values ) => {
        form.setFieldsValue( { companyRelationshipIds: values } ); 
        form.setFieldsValue( { companyRelationshipIdsAreModified: false } ); 
        form.setFieldsValue( { companyRelationshipIdsModified: [] } ); 
    },

    updateProductsValues: ( form, values ) => {
        form.setFieldsValue( { productIds: values } ); 
        form.setFieldsValue( { productIdsAreModified: false } ); 
        form.setFieldsValue( { productIdsModified: [] } ); 
    }, 

    updateLearningProfileValues: ( form, values ) => {
        form.setFieldsValue( { learningProfileIds: values } ); 
        form.setFieldsValue( { learningProfileIdsAreModified: false } ); 
        form.setFieldsValue( { learningProfileIdsModified: [] } ); 
    },

    updateEmployeeLocaleValues: ( form, values ) => {
        form.setFieldsValue( { employeeLocaleIds: values } ); 
        form.setFieldsValue( { employeeLocaleIdsAreModified: false } ); 
        form.setFieldsValue( { employeeLocaleIdsModified: [] } ); 
    },

    updateLocaleValues: ( form, values ) => {
        form.setFieldsValue( { localeIds: values } ); 
        form.setFieldsValue( { localeIdsAreModified: false } ); 
        form.setFieldsValue( { localeIdsModified: [] } ); 
    },

    /***************************
     * Save Handling
     ***************************/

    getCourseSaveData ( form ) {
        const result = {};
        this.setInitialValues( form, result );
        this.setILTValues( form, result );
        this.setLocaleValues( form, result );
        this.setHeroImageValues( form, result );
        this.setThumbnailImageValues( form, result );
        this.setPointsValues( form, result );
        this.setWeightValues( form, result );
        this.setIsFeaturedValues( form, result );
        return result;
    }
};

export default courseFormUtils;
